import React from 'react';
import ButtonActionWrapper from './ButtonActionWrapper';
import ButtonContentWrapper from './ButtonContentWrapper';
import { RadiusPropKeys } from 'src/app/styles/spacing';
import { useContentTranslation } from 'src/hooks/useContentTranslation';

export interface ButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'outline' | 'text-link' | 'brand-text-link';
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  href?: string;
  className?: string;
  loading?: boolean;
  radius?: RadiusPropKeys;
  decoration?: 'none' | 'underline';
  display?: 'inline' | 'block' | 'flex';
  noWrap?: boolean;
  skipTranslation?: boolean;
  'data-track-id'?: string;
  'data-track-type'?: string;
}

const Button = (props: ButtonProps): JSX.Element => {
  const { children, icon, iconPosition, loading, size, radius, noWrap, skipTranslation } = props;

  // Translate button text if it's a string
  const translatedChildren = useContentTranslation(
    typeof children === 'string' ? children : null,
    { skipTranslation }
  );

  // Use translated content if available, otherwise use original children
  const processedChildren = translatedChildren || children;

  const isDisabled = props.disabled || loading;

  return (
    <ButtonActionWrapper
      {...props}
      disabled={isDisabled}
      isIconOnly={!!icon && !children}
      radius={radius}
      noWrap={noWrap}
    >
      <ButtonContentWrapper
        icon={icon}
        iconPosition={iconPosition}
        size={size}
      >
        {processedChildren}
      </ButtonContentWrapper>
    </ButtonActionWrapper>
  );
};

export default Button;
